import jwtDecode from 'jwt-decode';

export const deserializeToken = token => jwtDecode(token);
